import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const StyledSettings = styled.div`
    display: grid;
    gap: 20px;
`;

export const Section = styled.div<{ $divider?: boolean }>`
    display: grid;
    gap: 10px;
    padding-top: ${(props) => (props.$divider ? '20px' : 0)};
    border-top: ${(props) => (props.$divider ? `1px solid ${props.theme.shades.white['5']}` : 'none')};
`;

export const Title = styled.span`
    ${styledReset.typography}
    display: block;
    font-family: 'Alliance No.1';
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    color: ${(props) => props.theme.colors.white};
`;

export const InputRadioGroupWrapper = styled.div`
    border-radius: 10px;
    background-color: ${(props) => props.theme.shades.white['5']};
`;

export const DisabledDeleteWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    flex-direction: column;
    svg {
        width: 16px !important;
        height: 16px !important;
        opacity: 0.3;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        flex-direction: row;
    }
`;

export const DisabledDeleteText = styled.div`
    color: #fff;
    opacity: 0.3;
    cursor: not-allowed;
    font-weight: 700;
    padding: 6px;
    font-size: 16px;
    display: none;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
    }
`;

export const DisabledDeleteTextLabel = styled.div`
    font-size: 14px;
    opacity: 0.5;
    margin-top: 7px;
`;
